import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconNavigationComponent } from "./med-icon-navigation.component";

@NgModule({
  declarations: [
    MedIconNavigationComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconNavigationComponent,
  ],
})
export class MedIconNavigationModule { }
